import RGBA from '../../Fonts/RGBA'
import RoomElement from './RoomElement'
import RoundedRect from '../../Rendering/RoundedRect'
import FontDefinition from '../../Fonts/FontDefinition'
import TextBoxRenderer from '../../Rendering/TextBoxRenderer'
import IconRenderer from '../../Rendering/IconRenderer'
import Arrow from '../../Rendering/Arrow'
import UrlExecutor from '../../Api/UrlExecutor'
import colorSchemeRepository from '../../Images/ColorSchemeRepository'
import TextMultilineBoxRenderer from "../../Rendering/TextMultilineBoxRenderer";
import game from "../../Game/GameInstance";


let fonts = {
  title : new FontDefinition('Roboto').size(16),
  badge : new FontDefinition('Roboto').size(12)
};

let roundedRect = new RoundedRect();
let textBoxRenderer = new TextBoxRenderer();
let subtextBoxRenderer = new TextMultilineBoxRenderer();
let iconRenderer = new IconRenderer();
let arrowRenderer = new Arrow(1);
let debug = false;

let colors = {

  transparentWhite : new RGBA(255).alpha(.1)

};

export default class TitleAndAttendeeBoxRenderer extends RoomElement
{

  constructor() {

    super(...arguments);

    this.hover = null;

  }

  render(ctx) {

    arrowRenderer.setScaleFactor(this.room.zoom);

    let hMargin = 20;
    let vMargin = 20;

    let attendeeText = null;
    let rightBox = null;

    let containingBox = this.getContainingBox(hMargin, vMargin);
    let iconBox = this.getIconBox();

    let urlArrowBox = this.getUrlArrowBox(containingBox);

    if (this.room.data.children && this.room.data.children.length) {
      rightBox = this.getButtonBox();
    }
    else{
      attendeeText = this.getAttendeeText();
      ctx.font = fonts.badge.scale(this.room.zoom);
      rightBox = this.getAttendeeBox(this.getTextWidth(ctx, attendeeText));
    }
    let titleBox = this.getTitleBox();

    this.spreadInContainer(containingBox, [iconBox, titleBox, rightBox], [5,10], 'middle');

    let titleText = this.getRoomTitle();

    if (debug) {
      this.debugBox(ctx, containingBox);
      this.debugBox(ctx, urlArrowBox);
      this.debugBox(ctx, iconBox);
      this.debugBox(ctx, rightBox);
      this.debugBox(ctx, titleBox);
    }

    this.renderUrlArrow(ctx, urlArrowBox);

    if (this.room.data.children && this.room.data.children.length) {
      ctx.fillStyle = colorSchemeRepository.get('foregroundText');
      this.renderButtons(ctx, rightBox);
    } else {
      this.renderAttendeeBadge(ctx, rightBox, attendeeText);
    }

    this.renderTitle(ctx, titleBox, titleText);
    if (this.room.data.mode === 'table') {

      subtextBoxRenderer.render(
          ctx,
          this.getRoomDescription(),
          fonts.title,
          this.scale(25),
          this.scale(50),
          this.roomWidth() - 50,
          (a) => this.scale(a),
          2,
          '...'
      )
   }

    ctx.font = fonts.title;
    iconRenderer.drawOn(ctx, 'location', this.scale(iconBox.x), this.scale(iconBox.y), this.scale(iconBox.width), this.scale(iconBox.height));
  }

  getAttendeeText() {
    let cnt = this.room.people.length;
    if (cnt === 1) {
      return '1 ' + this.room.game.onlyAttendeeTitle;
    }

    return cnt + ' ' + this.room.game.mulitpleAttendeesTitle;
  }

  renderUrlArrow(ctx, box) {

    arrowRenderer.draw(ctx, box.x, box.y, 'right', this.hover === 'url', 'transparent');
    this.room.hoverMask.add('url', 0, box.height, this.room.width, this.room.height).over(() => {
      this.setHover('url');
    }).out(() => {
      this.setHover(null);
    }).click(() => {

      UrlExecutor.execute(this.room.data.url);

    });

  }

  renderAttendeeBadge(ctx, box, text) {


    ctx.beginPath();
    roundedRect.drawOn(ctx, this.scale(box.x), this.scale(box.y), this.scale(box.width), this.scale(box.height), this.scale(box.height / 2));

    ctx.lineWidth = this.scale(1);
    ctx.strokeStyle = colorSchemeRepository.get('foregroundText');
    ctx.fillStyle = colors.transparentWhite;

    ctx.fill();
    ctx.stroke();

    ctx.fillStyle =colorSchemeRepository.get('foregroundText');
    ctx.fillText(text, this.scale(box.x + box.padding), this.scale(box.y + box.height - box.padding / 1.3));

  }

  renderButtons(ctx, box) {

    if (this.room.childrenRenderer.maxPages < 2) {
      return;
    }

    arrowRenderer.draw(ctx, box.x, box.y, 'left', this.hover === 'left', 'transparent');
    arrowRenderer.draw(ctx, box.x + box.width - box.height, box.y, 'right', this.hover === 'right', 'transparent');

    this.room.hoverMask.add('btnLeft', box.x, box.y, box.height, box.height).over(() => {
      this.setHover('left');
    }).out(() => {
      this.setHover(null);
    }).click(() => {
      // @todo : move logic to room
      this.room.childrenRenderer.requestPreviousPage();
    });

    this.room.hoverMask.add('btnRight', box.x + box.width - box.height, box.y, box.height, box.height).over(() => {
      this.setHover('right');
    }).out(() => {
      this.setHover(null);
    }).click(() => {
      // @todo : move logic to room
      this.room.childrenRenderer.requestNextPage();
    });

  }


  renderTitle(ctx, box, text)
  {
    const [textBoxWidth, iteration] = textBoxRenderer.render(ctx, text, fonts.title.scale(this.room.zoom), this.scale(box.x), this.scale(box.y + 1), this.scale(box.width), '...');

    if (iteration > 0) {
      this.room.hoverMask.add(this.room.data.id, box.x, box.y, box.width, box.height)
          .enable()
          .over(() => {
            const textWidth = this.getTextWidth(ctx, text) + 200;
            game.toolTipText.setWidth(ctx, textWidth);
            game.setToolTipText(this.room.x + box.x + (textBoxWidth / 2), this.room.y + box.y + box.height, text);
          })
          .out(() => {
            game.setToolTipText(null);
          });
    }

  }




  getTextWidth(ctx, text) {

    return this.unscale(ctx.measureText(text).width);

  }

  getContainingBox(hMargin, vMargin) {

    return {
      x : hMargin,
      y : vMargin,
      width : this.roomWidth() - hMargin * 2,
      height : 25
    };

  }

  getIconBox(hMargin, vMargin) {

    let width = 20;
    let height = 20;

    return {
      width,
      height,
      x : null,
      y : null
    };

  }

  getButtonBox() {

    let width = 30;
    let margin = 10;

    return {
      x : null,
      y : null,
      width: width + width + margin,
      height: width
    };

  }

  getUrlArrowBox(container) {

    let margin = 10;

    let width = 30;
    let height = 30;
    let x = container.x + container.width - width;
    let y = this.roomHeight() - container.x - width;

    return { width, height, x, y };

  }

  getAttendeeBox(textWidth) {

    let padding = 10;
    let width = textWidth + padding * 2;
    let height = fonts.badge.getSize(true) + padding;

    return {
      padding,
      width,
      height,
      x : null,
      y : null
    };

  }

  getTitleBox() {

    let width = null;
    let height = fonts.title.getSize(true) * 1.5;

    return {
      width : null,
      height,
      x : null,
      y : null
    };

  }


  setHover(x) {
    this.hover = x;
    this.room.needsRendering = true;
  }

}
